import { api } from '../../lib/api.ts';

export type AppKey = 'wapmeet' | 'wapsign' | 'wapstat' | 'wappro' | 'wapdocs';

export interface AppEntry {
  key: AppKey;
  name: string;
  url: string;
  tagline: string;
  // Still being built — shown with an "In development" badge and not launchable.
  inDevelopment: boolean;
}

// Per-user, per-app status for the account-hub dashboard. Mirrors the backend
// `AppStatus` from GET /api/apps/status (services/apps.ts):
//   - enabled          — caller's org has this app mapped
//   - hasAccount/role  — caller has a linked account there + their role
//   - isActive         — the linked account is active
//   - statusUnavailable — the linked app was unreachable (degrade, don't fail)
export interface AppStatus extends AppEntry {
  enabled: boolean;
  hasAccount: boolean;
  role: string | null;
  isActive: boolean;
  statusUnavailable: boolean;
  // Derived launcher tile (e.g. 'zone' = WapStat's Zone section).
  tile?: 'zone';
}

export const appsApi = {
  list: () => api.get<{ apps: AppEntry[] }>('/apps').then((r) => r.data.apps),
  status: () => api.get<{ apps: AppStatus[] }>('/apps/status').then((r) => r.data.apps),
  open: (app: AppKey, target?: 'zone') =>
    api.post<{ url: string }>(`/apps/${app}/open`, target ? { target } : undefined).then((r) => r.data),
};
